import { FC } from 'react';

import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import PaymentMethods from '@/features/v2/hh/components/PaymentMethods';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const PAYMENT_METHOD_NAME = 'payment_method';

interface Props {
  name?: string;
}

const RadioGroupPaymentMethod: FC<Props> = ({ name = PAYMENT_METHOD_NAME }) => {
  const { i18n } = useLingui();
  const { control, trigger } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        validate: (value) => !!value || i18n.t('Wybierz metodę płatności'),
      }}
      render={({ field, fieldState: { error } }) => (
        <FormItem>
          <FormControl>
            <PaymentMethods
              value={field.value}
              onValueChange={(v) => {
                field.onChange(v);
                trigger(name);
              }}
              aria-label={i18n.t('Metody płatności')}
            />
          </FormControl>
          {error && (
            <p className="caption-large text-red-400">{error.message}</p>
          )}
        </FormItem>
      )}
    />
  );
};

export default RadioGroupPaymentMethod;
